import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import introAnimation from '../animations/intro-animation.json';

interface IntroProps {
  onFinish: () => void;
}

export const Intro: React.FC<IntroProps> = ({ onFinish }) => {
  const [hasPlayed, setHasPlayed] = useState<boolean>(() => {
    try {
      return localStorage.getItem('hasSeenIntro') === 'true';
    } catch (error) {
      return false;
    }
  });
  // v5 SAFETY: si la Lottie crash, on a un fallback texte
  const [lottieFailed, setLottieFailed] = useState(false);

  useEffect(() => {
    if (hasPlayed) {
      onFinish();
      return;
    }

    const timer = setTimeout(() => {
      try {
        localStorage.setItem('hasSeenIntro', 'true');
        setHasPlayed(true);
        onFinish();
      } catch (error) {
        setHasPlayed(true);
        onFinish();
      }
    }, 2700);

    // v5 SAFETY: timeout de secours au cas où la Lottie plante et bloque tout
    // 5s maximum, même si autre chose plante
    const safetyTimer = setTimeout(() => {
      console.warn('[Intro] Safety timeout reached, forcing finish');
      onFinish();
    }, 5000);

    return () => {
      clearTimeout(timer);
      clearTimeout(safetyTimer);
    };
  }, [hasPlayed, onFinish]);

  if (hasPlayed) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-[100]"
      style={{ background: '#000000' }}
    >
      {introAnimation && !lottieFailed ? (
        <ErrorWrapper onError={() => setLottieFailed(true)}>
          <Lottie
            animationData={introAnimation}
            loop={false}
            style={{ width: '70vw', height: '70vh' }}
          />
        </ErrorWrapper>
      ) : (
        <div className="text-white text-3xl font-bold animate-pulse">
          Restomi
        </div>
      )}
    </div>
  );
};

// Mini error boundary pour la Lottie uniquement
class ErrorWrapper extends React.Component<
  { children: React.ReactNode; onError: () => void },
  { hasError: boolean }
> {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error: Error) {
    console.error('[Intro Lottie] crashed:', error);
    this.props.onError();
  }
  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}